module.exports = __webpack_public_path__ + "static/media/handleMainImg.48a67311.png";